"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types = require("./types");
exports.fetchRequest = () => ({
    type: types.FETCH_REQUEST,
});
exports.fetchSuccess = (config) => ({
    config, type: types.FETCH_SUCCESS,
});
exports.fetchFailure = (errorMessage) => ({
    errorMessage, type: types.FETCH_FAILURE,
});
//# sourceMappingURL=actions.js.map